"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Image = _interopRequireDefault(require("../Image"));
var _utils = require("../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable @typescript-eslint/prefer-optional-chain */

var ArticleComponent = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
    banner = props.banner,
    sharp = props.sharp,
    radius = props.radius,
    source = props.source,
    record = props.record,
    onCallbackHandle = props.onCallbackHandle,
    className = props.className,
    children = props.children,
    onClick = props.onClick,
    contentMaxHeight = props.contentMaxHeight,
    importFlexLayout = props.importFlexLayout,
    importFlexLayoutImage = props.importFlexLayoutImage,
    importAStyle = props.importAStyle,
    hrefText = props.hrefText,
    href = props.href,
    title = props.title,
    titleStyle = props.titleStyle,
    contentStyle = props.contentStyle,
    article = props.article,
    contentSvg = props.contentSvg,
    contentSvgText = props.contentSvgText,
    contentSvgImg = props.contentSvgImg,
    restProps = __rest(props, ["icon", "banner", "sharp", "radius", "source", "record", "onCallbackHandle", "className", "children", "onClick", "contentMaxHeight", "importFlexLayout", "importFlexLayoutImage", "importAStyle", "hrefText", "href", "title", "titleStyle", "contentStyle", "article", "contentSvg", "contentSvgText", "contentSvgImg"]);
  var _a = (0, _utils.fomateFileData)(contentSvgImg),
    url = _a.url,
    _b = _a.alt,
    alt = _b === void 0 ? '' : _b;
  var importPcClassName = {};
  var importMoClassName = {};
  // console.log(restProps)
  Object.keys(restProps || {}).forEach(function (item) {
    switch (item) {
      case 'pc':
        importPcClassName = restProps[item] || {};
        restProps.pc = null;
        break;
      case 'mo':
        importMoClassName = restProps[item] || {};
        restProps.mo = null;
        break;
      default:
        break;
    }
  });
  // 判断是否使用的样式类型 -pc or mobile
  var _c = (0, _react.useState)(true),
    currentClass = _c[0],
    setCurrentClass = _c[1];
  var _d = (0, _react.useState)(false),
    svgShow = _d[0],
    setSvgShow = _d[1];
  var contentRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(setCurrentClass);
    addOnMouseOver();
  }, []);
  var addOnMouseOver = function addOnMouseOver() {
    var _a;
    var myRef = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current;
    if (!myRef.classList.contains('has-svg')) return;
    var len = (_a = myRef === null || myRef === void 0 ? void 0 : myRef.childNodes) === null || _a === void 0 ? void 0 : _a.length;
    var svg = myRef === null || myRef === void 0 ? void 0 : myRef.childNodes[len - 1];
    // if (svg?.tagName !== 'svg') return;
    svg.onmouseover = function () {
      setSvgShow(true);
    };
    svg.onmouseleave = function () {
      setSvgShow(false);
    };
    svg.onclick = function (e) {
      e.stopPropagation();
    };
  };
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref,
    className: (0, _classnames["default"])('flex-default-article', className),
    style: currentClass ? importPcClassName : importMoClassName
  }, restProps, {
    onClick: function onClick() {
      if (!href) return;
      window.location.href = href;
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-default-article-container')
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: importFlexLayout,
    style: !importFlexLayout ? {
      display: 'flex',
      flexDirection: 'column'
    } : {}
  }, source && ( /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    className: importFlexLayoutImage,
    style: !importFlexLayoutImage && {
      margin: !!source && '0 0 12px 0',
      width: '163px',
      height: '54px'
    },
    source: source
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      wordBreak: 'break-word'
    },
    onClick: function onClick() {
      onCallbackHandle && onCallbackHandle(record);
    }
  }, title && ( /*#__PURE__*/_react["default"].createElement("strong", {
    className: 'wordBreak lineBreak',
    style: titleStyle
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('div-content'),
    style: contentStyle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: article || ''
    },
    ref: contentRef,
    className: contentSvg ? 'has-svg' : ''
  }), contentSvg ? ( /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-svg'
  }, svgShow ? ( /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-svg-posi'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: contentSvgText || ''
    }
  }), url ? /*#__PURE__*/_react["default"].createElement("img", {
    src: url,
    alt: alt
  }) : '')) : '')) : ''), href && ( /*#__PURE__*/_react["default"].createElement("a", {
    className: 'flex-default-article_a',
    style: importAStyle || {},
    href: href
  }, hrefText || "Learn more ", " >"))))));
});
ArticleComponent.displayName = 'TCIThumbnail';
var _default = exports["default"] = ArticleComponent;